import { render } from "./MonthlyLeadsChart.vue?vue&type=template&id=0b1c1552"
import script from "./MonthlyLeadsChart.vue?vue&type=script&lang=js"
export * from "./MonthlyLeadsChart.vue?vue&type=script&lang=js"
script.render = render

export default script